import { httpRequest } from "../../../../utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";
import { ISaleRoList, ISaleRoFields, ISaleRoDetail, ISaleRoSearch, Ids, Detailed, ISaleRoSettleAndWhConfirm, ISaleDetailsSearch, ISaleDetails } from "./saleRoTypes"

class SaleRoService {
    async page(searchVo: ISaleRoSearch) {
        const apiUrl = "/vrm-sa/sreturn/findPage";
        return await httpRequest.post<ISaleRoList>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/sreturn/findById/${id}`;
        return await httpRequest.get<ISaleRoDetail>(apiUrl);
    }

    async insert(insertVo: ISaleRoFields) {
        const apiUrl = "/vrm-sa/sreturn/insert";
        return await httpRequest.post<ISaleRoDetail>(apiUrl, insertVo);
    }
    async update(updateVo: ISaleRoFields) {
        const apiUrl = "/vrm-sa/sreturn/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    // 库房确认
    async warehousing(params: ISaleRoSettleAndWhConfirm) {
        const apiUrl = "/vrm-sa/sreturn/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //明细删除
    async materialDelete(params: Detailed) {
        const apiUrl = "/vrm-sa/sreturn/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //结算
    async settl(params: ISaleRoSettleAndWhConfirm) {
        const apiUrl = "/vrm-sa/sreturn/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //作废
    async invalidate(params: object) {
        const apiUrl = "/vrm-sa/sreturn/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //销售单分页查询
    async saleDetails(params: ISaleDetailsSearch) {
        const apiUrl = "vrm-sa/sale/details/findPage";
        return await httpRequest.post<IPage<ISaleDetails>>(apiUrl, params);
    }
    async printing(params: object) {
        const apiUrl = "/vrm-sa/sreturn/printing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //销售单批量导出
    async export(params: ISaleRoSearch) {
        const apiUrl = "/vrm-sa/sreturn/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 600000 });
    }
    //销售单详情导出
    async detailsExport(params: object) {
        const apiUrl = "/vrm-sa/sreturn/detailsExport";
        return await httpRequest.postFile(apiUrl, params, { timeout: 600000 });
    }
}


export const saleRoService = new SaleRoService();